import React from 'react';
import Stars from '../../../../CommonComponents/StarRating/StarRating';
import { formatDate } from '../../../../utils/helper';
import './reviewList.scss';

const renderImage = (src, index) => {
  return (
    <div key={index} className="margin-t10 margin-r4">
      <img alt="review" className="structure" src={src} />
    </div>
  );
};

const Review = props => {
  const {
    reviewId,
    reviewTitle,
    reviewDetail,
    reviewee,
    reviewDate,
    noOfStars,
    className = '',
    startId,
    images,
  } = props;
  const imagesArray = [];
  if (images?.length) {
    images.length = Math.min(images.length, 3);
    images.forEach((image, index) => {
      imagesArray.push(renderImage(image.thumbUrl, index)); // need not give key more than 0;
    });
  }
  return (
    <div className={`${className} user-rating`}>
      <Stars defaultRating={Math.round(noOfStars)} ratingid={startId || reviewId}></Stars>
      <div className="fs16 text-color_grey_black margin-t15 fw-bold text-capitalize">
        {reviewTitle}
      </div>
      <div className="fs14 margin-t10 user-comment">{reviewDetail}</div>
      <div className="fs14 margin-t10 user-date">
        <span className="text-capitalize">{reviewee}</span> -{' '}
        {formatDate(new Date(reviewDate).getTime(), 'D MMM', true)}
      </div>
      {/* <div className="display-flex margin-t15">
            <div className="fs12 text-color_dull_black">Was This Review Helpful? <i className="fa fa-thumbs-up margin-l10 cursor-pointer" style={{ color: '#FAA61A' }} aria-hidden="true"></i></div>
        </div> */}
      {images && <div className="display-flex align-items-center">{imagesArray}</div>}
    </div>
  );
};

export default Review;
